import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EffectsListReducerState } from '../reducers/effects-list.reducer';

/**
 * Key of effects list
 */
export const EFFECTS_LIST_KEY = 'effectsList';

/**
 * Feature selector of effects list store
 */
export const getEffectsListFeatureState = createFeatureSelector<EffectsListReducerState>(EFFECTS_LIST_KEY);

/**
 * Selector to get effects list
 */
export const getEffectsList = createSelector(getEffectsListFeatureState, state => state.effectsList);
